import { User } from "@scrile/api-provider/dist/api/UserProvider";
import { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";

import config from "config";

export function isPerformer(user: UserPublicData | User | null) {
  return user?.role === config.userPerformerRole;
}
